/* global PhotoSwipe, PhotoSwipeLightbox, PhotoSwipeDynamicCaption: false */

export default class PhotoSwipeTheme {
    constructor(gallery) {
        if (!gallery) return;

        this.gallery = gallery;
        this.options = gallery.dataset.photoswipeOptions;

        if (this.options) {
            this.options = JSON.parse(this.options);
        }

        this.init();
    }

    init() {
		let lightbox = new PhotoSwipeLightbox(
			Object.assign(
				{
				gallery: this.gallery,
				children: 'a',
				pswpModule: PhotoSwipe,
			}, this.options)
		);

		if (this.options.captionEl && PhotoSwipeDynamicCaption) {
			new PhotoSwipeDynamicCaption(lightbox, {
				type: 'below',
				captionContent: (slide) => {
					if (slide.data.element.dataset.pswpCaption) {
						return slide.data.element.dataset.pswpCaption;
					}
					return slide;
				}
			});
		}

		lightbox.init();
    }
}

// Photoswipe
Array.from(document.querySelectorAll('[data-photoswipe-options]')).map(el => new PhotoSwipeTheme(el));
